import { render, staticRenderFns } from "./RangoTemporal.vue?vue&type=template&id=2226d7fe&"
import script from "./RangoTemporal.vue?vue&type=script&lang=js&"
export * from "./RangoTemporal.vue?vue&type=script&lang=js&"
import style0 from "./RangoTemporal.vue?vue&type=style&index=0&id=2226d7fe&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports